export enum WriterEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  LEGAL = 'LEGAL',
}
